import React, { Component } from "react";
import Select from "react-select";

class DropdownSelect extends Component {
  _handleChangeInSelect = value => {
    this.props.returnValue(value);
  };

  render() {
    const { options, currentValue, defaultValue, isDisabled } = this.props;
    let value = options.find(option => option.value === currentValue);
    if (value === undefined && defaultValue) {
      value = defaultValue;
    }
    return (
      <Select
        options={options}
        isSearchable={false}
        value={value}
        isDisabled={isDisabled}
        onChange={selectedValue => this._handleChangeInSelect(selectedValue)}
        data-test="dropdownselect-select"
      />
    );
  }
}

export default DropdownSelect;



// WEBPACK FOOTER //
// ./src/commonComponents/DropdownSelect/DropdownSelect.js